import { Box, Container, LinearProgress, ListItemText, Stack } from "@mui/material";


export function UPage(props) {

    return <Box sx={{
        paddingBottom: 50,
    }}>
        {props.children}
    </Box>
}

export function UColumn(props) {
    return <Container {...props} xs="auto">
        {props.children}
    </Container>
}

export function USection(props) {
    const { sx, columSx, margin, padding, bgcolor, ...rest } = props;
    const backgroundColor = bgcolor ? bgcolor : 'transparent'
    return <Box sx={{
        marginTop: margin,
        marginBottom: margin,
        paddingTop: padding,
        paddingBottom: padding,
        backgroundColor: backgroundColor,
        paddingRight: 1,
        paddingLeft: 1,
        ...props.sx
    }}>
        <UColumn sx={{ position: 'relative' }}>
            <Stack  {...rest}>
                {props.children}
            </Stack>
        </UColumn>
    </Box>
}
export function UStretchSection(props) {
    const { sx, columSx, margin, padding, bgcolor, ...rest } = props;
    const backgroundColor = bgcolor ? bgcolor : 'transparent'
    return <Box sx={{
        marginTop: margin,
        marginBottom: margin,
        paddingTop: padding,
        paddingBottom: padding,
        backgroundColor: backgroundColor,
        paddingRight: 1,
        paddingLeft: 1,
        ...props.sx
    }}>
        <UColumn sx={{ height: '100%' }}>
            <Stack sx={{ height: '100%' }}  {...rest}>
                {props.children}
            </Stack>
        </UColumn>
    </Box>
}

export function ULine(props) {
    return <Stack
        justifyContent={"space-between"}
        direction="row"
        alignItems="center"
        {...props}>
        {props.children}
    </Stack>
}
export function URow(props) {
    return <Stack
        justifyContent={"space-between"}
        direction="row"
        {...props}>
        {props.children}
    </Stack>
}
export function ULoading(props) {
    const { ...rest } = props
    return <LinearProgress color="secondary" {...rest} />
}


export function UMargin(props) {
    const { margin, ...rest } = props
    return <Box  {...rest} sx={{
        marginTop: margin || 2,
        marginBottom: margin || 2,
        ...props.sx
    }}>{props.children}</Box>
}
export function UMarginTop(props) {
    const { margin, ...rest } = props
    return <Box  {...rest} sx={{
        marginTop: margin || 1,
        ...props.sx
    }}>{props.children}</Box>
}
export function UMarginBottom(props) {
    const { margin, ...rest } = props
    return <Box  {...rest} sx={{
        marginBottom: margin || 1,
        ...props.sx
    }}>{props.children}</Box>
}
export function USticky(props) {
    const { top, zIndex, ...rest } = props
    return <Box {...rest} sx={{
        position: 'sticky',
        top: top || 0,
        zIndex: zIndex || 100,
        ...rest.sx
    }}>
        {props.children}
    </Box>
}
export function UFooter(props) {
    const { sx, ...rest } = props

    return <Stack {...rest} sx={{
        position: 'fixed',
        bottom: 0,
        left: 0,
        right: 0,
        ...sx,
    }} />
}
export function UFullPage(props) {
    const { sx, ...rest } = props;

    return <Stack sx={{
        position: 'absolute',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        ...sx,
    }} {...rest} />
}